export default function uniqBy(arr, key = 'id') {
  const seen = new Set();

  return arr.filter(el => {
    const duplicate = seen.has(el[key]);
    seen.add(el[key]);
    return !duplicate;
  });
}
